var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout--full-page"},[_c('div',{staticClass:"z-40 absolute top-0 right-0"},[_c('i18n',{staticClass:"p-8"})],1),_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-40 absolute h-32 w-32 vx-col hidden lg:block lg:w-2/3"},[_c('div',{staticClass:"pt-8 pl-10 left-0 top-0 h-16 w-16"})])
}]

export { render, staticRenderFns }